import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchFilter from "../../../components/search-filter";
import { formatDateTime, getTimeInAmPm, startLoader, stopLoader } from "../../../lib/utils";
import { getAllMembers, getMemberCount } from "../../member/helper/api";
import { isAuthenticated } from "../../../auth";
// import config from "../../../config";
import client from "../../../clients";
import { removeMemberFromAppointment, saveAppointMent } from "../helper/api";
import Toast from "../../../lib/toast";
import { getAllParameters } from "../../parameters/helper/api";
import FlatPicker from 'flatpickr';
let flatpickr;

const BookAppointment = (props) => {

  const flatpickrInitialized = useRef(false);
  const [isButtonLock,setButtonLock] = useState(true);
  const [blockSlotButtonLock,setSlotButtonLock]  = useState(false);
  const [selectedGym, setSelectedGym] = useState("");
  const [parameters,setParameters] = useState([]);
  const [selectedMembers,setSelectedMembers] = useState([])
  var pageSize = 20;
  const [isMemberSpinnerLoader, setMemberSpinnerLoader] = useState(false);
  var [pageNo,setPageNo] = useState(1);
  var [pageCount,setPageCount] = useState(1);
  var [total,setTotal] = useState(1);
  const [Members, setMembers] = useState([]);
  const [appointmentSlotDetails,setAppointmentSlotDetails] = useState('');
  const [searchKey, setSearchKey] = useState("");
  const [currentElementId, setCurrentElementId] = useState("");
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const {user,token} = isAuthenticated();
  const [isSelectedMemberListOpen, setSelectedMemberListOpen] = useState(false);
  const [selectedUserAppointment, setSelectedUserAppointment] = useState([
    // sample
    // {
    //   userInfo: {
    //     name:"Test User",
    //     phone:"+91 83737373737"
    //   }
    // }
  ]);


  const RemoveMemberFromAppointment = memberId => async event =>{
    try{
      await startLoader()
      const payload = {
        memberId,
        appointmentId:props.appointmentSlotDetails.extendedProps.appointmentId
      };
      const response = await removeMemberFromAppointment(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
         new Toast({
          type:"success",
          duration:3000,
          message:"Member successfully removed from this slot"
        })
        setSelectedUserAppointment(oldstate=>{
          let findIndex = oldstate.findIndex(d=>d._id == memberId);
          if(findIndex>-1) oldstate.splice(findIndex,1);
          return [...oldstate];
        })
      }

      await stopLoader();
    }catch(error){
      await stopLoader();
    }
  }


  const GetAllParamaters = async () =>{
    try{
      const params = {
        type:"appointmentType",
        noLimit:"noLimit"
      }
      const response = await getAllParameters(user._id,token,params);
      if(!response.error){
        setParameters(response);
      }
    }catch(error){

    }
  }

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      if(id.includes('booking-end-date')){
        flatpickr=FlatPicker("#"+id, {
          disableMobile: true,
          dateFormat: "Y-m-d",
          onChange: (e) => {

            setSelectedMembers(oldstate=>{
              let findIndex = oldstate.findIndex(d=>d.member && d.member._id == `${id}`.split("-")[ `${id}`.split("-").length-1]);
              if(findIndex>-1) oldstate[findIndex].tillDate = e[0];
              return [...oldstate];
            })

          },
        });

        flatpickr.open();
      }
    }
  };


  const selectAppointmentType = (type) => {
    setSelectedAppointmentType(type)
  }


  const bookAppointment = async (status) =>{
    try{
      await startLoader()
      setButtonLock(true)
      setSlotButtonLock(true);
      const payload = {
        type:selectedAppointmentType,
        weekDayName:appointmentSlotDetails.extendedProps.dayName,
        appointmentSlotId:appointmentSlotDetails.extendedProps.appointmentSlotId,
        slotRange:appointmentSlotDetails.extendedProps.slotRange,
        startTime:appointmentSlotDetails.extendedProps.slotStartTime,
        endTime:appointmentSlotDetails.extendedProps.slotEndTime,
        assigedUser:appointmentSlotDetails.extendedProps.assigedUser,
        branchId:appointmentSlotDetails.extendedProps.branchId,
        gymId:appointmentSlotDetails.extendedProps.gymId,
        appointmentDate:new Date(appointmentSlotDetails.start),
        appointmentDateString:formatDateTime(new Date(appointmentSlotDetails.start)),
        actiontype:"bulk"
      };
      if(status) payload.status = status;
      const memberPayloads = await Promise.all(selectedMembers.map(member=>{
        return {
          weekDays:member.weekdays,
          memberId:member.member._id,
          tillDate:member.tillDate
        };
      }));
      payload.memberPayloads=memberPayloads;
      const response = await saveAppointMent(user._id,token,payload);
      if(!response.error){
        new Toast({
          type:"success",
          message:"Appointment saved successfully",
          duration:3000
        })
        props.updateSlotsDetails({appointmentDetails:appointmentSlotDetails,appointment:response,action:status?"blocked":"booked"});
        if(props.handleCloseReportModal) props.handleCloseReportModal();
        else props.handleCloseModal()
      }else{
        new Toast({
          type:"warning",
          message:response.error,
          duration:3000
        })
      }
      await stopLoader()
    }catch(error){
      await stopLoader()
    }
    setButtonLock(false)
    setSlotButtonLock(false)
  }

  const handleSearchingData = (data) => {
    setSearchKey(data);
  }

  const handleSelectMembers = member =>{
    setSelectedMembers(oldstate=>{
      let findIndex = oldstate.findIndex(d=>d.member && d.member._id == member._id);
      if(findIndex == -1) oldstate.push({member:{...member},tillDate:null,weekdays:[]});
      else oldstate.splice(findIndex,1);
      return [...oldstate]
    })
  }


  const GetMemberParams = () => {
    let params = {
      pageNo: pageNo,
      pageSize: pageSize
    };
    params.activationStatus ="activate";
    if (searchKey) params.q = searchKey;
    if (appointmentSlotDetails) params.gymIDs = appointmentSlotDetails.extendedProps.gymId;
    if (appointmentSlotDetails) params.branchIDs = appointmentSlotDetails.extendedProps.branchId;
    let memberIds = [];
    try{
      memberIds = (props.appointmentSlotDetails && props.appointmentSlotDetails.extendedProps && props.appointmentSlotDetails.extendedProps.memberIDs)?props.appointmentSlotDetails.extendedProps.memberIDs:[];
    }catch(error){

    }
    if(memberIds.length) params.notListIDs = memberIds;
    return params;
  }



  const GetAllMember = async (isReUpdateMembers) => {
    try {
      let params = GetMemberParams();
      let members = await getAllMembers(user._id, token, params);
      if(!members.error) {
        if (isReUpdateMembers) setMembers(members)
        else setMembers([...Members, ...members]);
      }else{
        //handle error
      }
    } catch (error) {
      //do something
    }
  }

  const GetMemberCount = async () => {
    try {
      let params = GetMemberParams();
      delete params.pageNo;
      delete params.pageSize;
      let response = await getMemberCount(user._id, token, params);
      if(!response.error){
        pageNo = 1;
        setPageNo(pageNo)
        setPageCount(Math.ceil(response.COUNT / pageSize))
        setTotal(response.COUNT)
      }
    } catch (error) {
      // so something
    }
  }
  

  const handleScroll = async event => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isMemberSpinnerLoader) {
        pageNo = pageNo + 1;
        setPageNo(pageNo)
        setMemberSpinnerLoader(true)
        await GetAllMember();
        setMemberSpinnerLoader(false)
      }
    } catch (error) {
      setMemberSpinnerLoader(false)
    }
  }

  const toggleViewAppointedMembers = () => {
    setSelectedMemberListOpen(!isSelectedMemberListOpen)
  }


  const getTillDate = (member) =>{
    let date = "";

    let findMember = selectedMembers.find(d=>d.member && d.member._id == member._id);

    if(findMember && findMember.tillDate) date = findMember.tillDate;

    return formatDateTime(date);
  }

   const isWekDaySelected = (member,weekday) =>{
    let index = -1;

    let findMember = selectedMembers.find(d=>d.member && d.member._id == member._id);

    if(findMember && findMember.weekdays) index = findMember.weekdays.indexOf(weekday);

    return index != -1;
  }
 
  const selectWeekDay = (member,weekday) => event =>{
    setSelectedMembers(oldstate=>{
      let findMemberIndex = selectedMembers.findIndex(d=>d.member && d.member._id == member._id);
      if(findMemberIndex > -1){
        const index =oldstate[findMemberIndex].weekdays.indexOf(weekday);
        if(index == -1){
          oldstate[findMemberIndex].weekdays.push(weekday);
        }else{
          oldstate[findMemberIndex].weekdays.splice(index,1);
        }
      }
      return [...oldstate];
    })
  }


  const getAppointmentBookedCount = async () =>{
    if(props.appointmentSlotDetails && props.appointmentSlotDetails.extendedProps && props.appointmentSlotDetails.extendedProps.memberIDs){
      const params = {
        ids:props.appointmentSlotDetails.extendedProps.memberIDs
      }
      const response = await getAllMembers(user._id,token,params);
      if(!response.error){
        setSelectedUserAppointment(response);
        let members = [...response];
        for(const member of members){
          setSelectedMembers(oldstate=>{
            oldstate.push({member,tillDate:null,weekdays:[]})
            return [...oldstate];
          })
        }
      }
    }
  }

  const getSotLimit = useCallback(()=>{
    let val=1;
    try{
      val=props.appointmentSlotDetails.extendedProps.slot_limit;
    }catch{

    }
    return val;
  },[props])

 useEffect(() => {
  if (!selectedMembers.length || flatpickrInitialized.current) return;

  flatpickrInitialized.current = true;

  return () => {
    flatpickrInitialized.current = false;
  };
}, [selectedMembers]);

  useEffect(()=>{
    if(selectedMembers.length && selectedAppointmentType){
      setButtonLock(false)
    }else{
      setButtonLock(true);
    }
  },[selectedMembers,selectedAppointmentType])

  useEffect(async () => {
    if(props.appointmentSlotDetails) setAppointmentSlotDetails(props.appointmentSlotDetails);

    try{
      await startLoader();
      await GetAllParamaters();
      await getAppointmentBookedCount();
      await stopLoader();
    }catch(error){
      await stopLoader()
    }
  },[props])


  useEffect(async () => {
     if(appointmentSlotDetails){
      try {
        setMemberSpinnerLoader(true);
        await GetMemberCount();
        await GetAllMember(true);
        setMemberSpinnerLoader(false);
      } catch (error) {
        //do something 
        setMemberSpinnerLoader(false);
      }
     }
  }, [searchKey,appointmentSlotDetails]);

  return(
    <div className={window.innerWidth < 768 ? "w-full h-full" : "modal-test-container d-flex"}>
      <div className={window.innerWidth < 768 ? "w-full h-full" : "book-appointment-modal slideBottomToTop flex-item"}>
        {
          window.innerWidth > 767 && (
            <div className="modal-header space-between" style={{height:"64px", background:"var(--darkBlue)"}}>
              <div className="flex-item">
                <p className="flex-item fs-18 font-weight-700 color-white">Manage Appointment</p>
                {appointmentSlotDetails && <p className="flex-item fs-12 font-weight-700 color-white">{formatDateTime(new Date(appointmentSlotDetails.start))} - {getTimeInAmPm(new Date(appointmentSlotDetails.start))}</p>}
              </div>
              <div onClick={()=>props.handleCloseModal()} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }

        <div className="w-full p-l-12 p-r-12">
          <div onClick={()=>toggleViewAppointedMembers()} className="flex-item d-flex space-between bg-white m-t-12 m-b-12 p-t-12 p-b-12 p-l-12 p-r-12" style={{borderRadius:"20px"}}>
            <p className="flex-item color-dark-blue font-weight-700 fs-16">{selectedUserAppointment.length} of {getSotLimit()} Booked </p>
            {
              isSelectedMemberListOpen ? (
                <svg className="flex-item" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.85451 4.14662C4.80803 4.10014 4.75285 4.06326 4.69212 4.03811C4.63139 4.01295 4.5663 4 4.50056 4C4.43483 4 4.36974 4.01295 4.309 4.03811C4.24827 4.06326 4.19309 4.10014 4.14661 4.14662C4.10013 4.1931 4.06326 4.24829 4.0381 4.30902C4.01295 4.36976 4 4.43485 4 4.50059C4 4.56633 4.01295 4.63143 4.0381 4.69216C4.06326 4.75289 4.10013 4.80808 4.14661 4.85456L7.64612 8.35229C5.91316 9.53475 4.70663 11.3436 4.28059 13.3979C4.2672 13.4622 4.2666 13.5285 4.27882 13.593C4.29104 13.6575 4.31585 13.7189 4.35183 13.7739C4.38781 13.8288 4.43425 13.8761 4.4885 13.9131C4.54276 13.95 4.60376 13.9759 4.66804 13.9893C4.73231 14.0027 4.79859 14.0033 4.8631 13.9911C4.9276 13.9789 4.98907 13.9541 5.04399 13.9181C5.09891 13.8821 5.1462 13.8357 5.18317 13.7814C5.22014 13.7272 5.24606 13.6662 5.25945 13.6019C5.45084 12.6786 5.82421 11.8028 6.35776 11.0254C6.89131 10.248 7.57435 9.58473 8.36701 9.07423L9.94979 10.6561C9.53728 10.952 9.19408 11.3341 8.944 11.7759C8.69393 12.2178 8.54297 12.7087 8.5016 13.2147C8.46023 13.7207 8.52943 14.2297 8.70442 14.7062C8.8794 15.1828 9.15597 15.6156 9.51494 15.9746C9.87391 16.3336 10.3067 16.6102 10.7832 16.7852C11.2598 16.9602 11.7687 17.0294 12.2747 16.988C12.7806 16.9466 13.2715 16.7957 13.7133 16.5456C14.1551 16.2955 14.5372 15.9523 14.8331 15.5397L19.1455 19.8534C19.2394 19.9473 19.3667 20 19.4994 20C19.6322 20 19.7595 19.9473 19.8534 19.8534C19.9473 19.7595 20 19.6322 20 19.4994C20 19.3666 19.9473 19.2393 19.8534 19.1454L4.85451 4.14662ZM12.1235 10.0032L15.486 13.3659C15.4521 12.4849 15.087 11.6491 14.4636 11.0256C13.8402 10.4022 13.0045 10.037 12.1235 10.0032ZM9.52985 7.41036L10.3327 8.2133C10.877 8.07157 11.4371 7.99999 11.9995 8.00032C15.205 8.00032 18.0556 10.3271 18.7385 13.6019C18.7656 13.7318 18.8432 13.8457 18.9542 13.9185C19.0652 13.9912 19.2005 14.0169 19.3305 13.9898C19.4604 13.9628 19.5743 13.8852 19.647 13.7742C19.7198 13.6632 19.7455 13.5278 19.7184 13.3979C18.9415 9.67318 15.692 7.00039 11.9995 7.00039C11.1446 7.00039 10.3117 7.14338 9.52985 7.41036Z" fill="var(--darkBlue)"/>
                </svg>
              ) : (
                <svg className="flex-item" width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="var(--darkBlue)"/>
                </svg>
              )
            }
          </div>
        </div>
       
        {
          isSelectedMemberListOpen ? (
            <div className="w-full p-l-12 p-r-20" style={{height:"66vh", overflowY:"auto"}}>
              {
                selectedUserAppointment.map((member, index) => {
                  return(
                    <div className="d-flex space-between p-b-20 p-t-12 w-full" style={{borderBottom: Members.length != index + 1 && "1px solid #ffffff"}}>
                      <div style={{alignSelf:"flex-start", width:"90%"}}>
                        <div className="flex-item d-flex">
                          {
                            member.user && member.user.length > 0 && member.user[0].profileID ? (
                              <img className="table-item-profile d-flex flex-item" src={`${client.config.API_URL}/image/file/${member.user[0].profileID}/auto/auto/70?${Date.now()}`} />
                            ) : (
                              <div className="table-item-profile d-flex flex-item" style={{backgroundColor: '#5d883c'}}>
                                <p className='flex-item margin-auto' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>{`${member.userInfo.name}`.trim()[0]}</p>
                              </div>
                            )
                          }
                          <div className="flex-item m-l-8">
                            <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{member.userInfo.name}</p>
                            <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{member.userInfo.phone}</p>
                          </div>
                        </div>
                      <div className="d-flex m-t-20">
                         <div onClick={()=>toggleInputFields(`booking-end-date-${member._id}`)} className={`${(currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'booking-end-date' || getTillDate(member)) ? "1px solid var(--darkBlue)" : "", width: "120px", height:"56px" }}>
                            <div className="flex-item d-flex">
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "10px" : "14px", color: (currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "var(--darkBlue)" : "", transition: "180ms" }}>Book till date</p>
                            </div>
                            <input id={`booking-end-date-${member._id}`} value={getTillDate(member)} style={{ color: "#2b2b2b", pointerEvents: currentElementId === `booking-end-date-${member._id}` ? "auto" : "none" }} className={`${(currentElementId === `booking-end-date-${member._id}` || getTillDate(member)) ? "active-input-field m-t-4" : "inactive-input-field"} fs-16`} type="text" placeholder='YYYY-MM-DD' readOnly/>
                          </div>
                        <div className="m-l-12">
                          <p className="fs-14 m-b-3 font-weight-700 color-dark-blue">Select Weekdays</p>
                          <div className="d-flex">
                            <div onClick={selectWeekDay(member,"Mon")} className={`global-round-btn ${isWekDaySelected(member,"Mon")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Mon")&&`text-white`} flex-item p-l-8 p-r-8`}>Mon</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Tue")} className={`global-round-btn ${isWekDaySelected(member,"Tue")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Tue")&&`text-white`} flex-item p-l-8 p-r-8`}>Tue</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Wed")} className={`global-round-btn ${isWekDaySelected(member,"Wed")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Wed")&&`text-white`} flex-item p-l-8 p-r-8`}>Wed</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Thu")} className={`global-round-btn ${isWekDaySelected(member,"Thu")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Thu")&&`text-white`} flex-item p-l-8 p-r-8`}>Thu</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Fri")} className={`global-round-btn ${isWekDaySelected(member,"Fri")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Fri")&&`text-white`} flex-item p-l-8 p-r-8`}>Fri</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Sat")} className={`global-round-btn ${isWekDaySelected(member,"Sat")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Sat")&&`text-white`} flex-item p-l-8 p-r-8`}>Sat</p>
                            </div>
                            <div onClick={selectWeekDay(member,"Sun")} className={`global-round-btn ${isWekDaySelected(member,"Sun")&&`global-round-btn-active`} d-flex m-r-6`}>
                              <p className={`text ${isWekDaySelected(member,"Sun")&&`text-white`} flex-item p-l-8 p-r-8`}>Sun</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>
                      {
                        (props && props.appointmentSlotDetails && props.appointmentSlotDetails.extendedProps && props.appointmentSlotDetails.extendedProps.appointmentId) && (
                          <div className="global-round-btn-alert d-flex" style={{alignSelf:"flex-start"}}>
                            <svg onClick={RemoveMemberFromAppointment(member._id)} className="fill-svg cursor-pointer flex-item margin-auto" width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.616 16.0005C2.168 16.0005 1.78667 15.8431 1.472 15.5285C1.15733 15.2138 1 14.8328 1 14.3855V2.00047H0V1.00047H4V0.230469H10V1.00047H14V2.00047H13V14.3855C13 14.8455 12.846 15.2298 12.538 15.5385C12.23 15.8471 11.8453 16.0011 11.384 16.0005H2.616ZM12 2.00047H2V14.3855C2 14.5648 2.05767 14.7121 2.173 14.8275C2.28833 14.9428 2.436 15.0005 2.616 15.0005H11.385C11.5383 15.0005 11.6793 14.9365 11.808 14.8085C11.9367 14.6805 12.0007 14.5391 12 14.3845V2.00047ZM4.808 13.0005H5.808V4.00047H4.808V13.0005ZM8.192 13.0005H9.192V4.00047H8.192V13.0005Z" fill="#E33A34"/>
                            </svg>
                          </div>
                        )
                      }
                    </div>
                  )
                })
              }
            </div>
          ) : (
            <div className="w-full">
              <div className="w-full p-l-12 p-r-12">
                <div onClick={()=>toggleInputFields('appointment-type')} className={`${currentElementId == "appointment-type" || selectedAppointmentType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "appointment-type" || selectedAppointmentType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
                  <div className="flex-item d-flex" style={{marginTop: (currentElementId == "appointment-type" || selectedAppointmentType) ? "4px" : ""}}>
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "appointment-type" || selectedAppointmentType) ? "10px" : "16px", lineHeight: (currentElementId == "appointment-type" || selectedAppointmentType) ? "10px" : "16px", color: (currentElementId == "appointment-type" || selectedAppointmentType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Appointment Type</p>
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" style={{ transform: currentElementId == "appointment-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  {
                    selectedAppointmentType ? (
                      <div className="w-full d-flex m-t-8 m-b-8">
                        <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{selectedAppointmentType}</p>
                      </div>
                    ) : 
                    <div className={`${(currentElementId == "appointment-type" || selectedAppointmentType) ? "active-input-field" : "inactive-input-field"} w-full d-flex m-t-6`}>
                      <p id="appointment-type" className={`color-grey-06 font-weight-300 fs-16`}>{selectedAppointmentType?selectedAppointmentType:"Select Appointment Type"}</p>
                    </div>
                  }
                  
                  {
                    currentElementId == "appointment-type" && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : selectedAppointmentType && "70px"}}>
                        <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                          {
                            parameters.map((data, index) => {
                              return (
                                <div onClick={()=>selectAppointmentType(data.name)} className="global-input-field-arrow-dropdown-item d-flex">
                                  <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data.name}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
              <div className="w-full" style={{padding:"12px 0px", height: window.innerWidth < 768 ? "80%" : "46vh"}}>
                <div className="w-full p-l-12 p-r-12">
                  <SearchFilter searchType={"Member"} isSticky={false} isSearchEnabled={true} isFilterEnabled={false} searchingData={handleSearchingData} selectedGym={selectedGym} count={total}/>
                </div>
                <div className="w-full m-t-10 p-l-12 p-r-12 apt-user-selection-container" onScroll={handleScroll} style={{height:"90%"}}>
                  {
                    Members.map((member, index) => {
                      return( 
                        <div className="p-b-12 p-t-12" style={{borderBottom: Members.length != index + 1 && "1px solid #ffffff"}}>
                          <div className="flex-item d-flex">
                            <input checked={selectedMembers.findIndex(d=>d.member._id == member._id)!=-1} onClick={()=>handleSelectMembers(member)} className="flex-item m-r-8" style={{width:"16px", height:"16px"}} type="radio" name={"member-"+member._id} />
                            {
                              member.user.length > 0 && (
                                member.user[0].profileID ? (
                                  <img className="table-item-profile d-flex flex-item" src={`${client.config.API_URL}/image/file/${member.user[0].profileID}/auto/auto/70?${Date.now()}`} />
                                ) : (
                                  <div className="table-item-profile d-flex flex-item" style={{
                                    backgroundColor: '#5d883c'
                                  }}>
                                    <p className='flex-item margin-auto' style={{ color: '#ffffff', fontSize: 14, margin: '0 auto' }}>{`${member.userInfo.name}`.trim()[0]}</p>
                                  </div>
                                )
                              )
                            } 
                            <div className="flex-item m-l-8">
                              <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{member.userInfo.name}</p>
                              <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{member.userInfo.phone}</p>
                            </div>
                          </div>
                          {
                            selectedMembers.findIndex(d=>d.member._id == member._id)!=-1 && (
                              <div className="d-flex m-t-16 m-b-10 p-l-26">
                                <div onClick={()=>toggleInputFields(`booking-end-date-${member._id}`)} className={`${(currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'booking-end-date' || getTillDate(member)) ? "1px solid var(--darkBlue)" : "", width: "120px", height:"56px" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "10px" : "14px", color: (currentElementId == `booking-end-date-${member._id}` || getTillDate(member)) ? "var(--darkBlue)" : "", transition: "180ms" }}>Book till date</p>
                                  </div>
                                  <input id={`booking-end-date-${member._id}`} value={getTillDate(member)} style={{ color: "#2b2b2b", pointerEvents: currentElementId === `booking-end-date-${member._id}` ? "auto" : "none" }} className={`${(currentElementId === `booking-end-date-${member._id}` || getTillDate(member)) ? "active-input-field m-t-4" : "inactive-input-field"} fs-16`} type="text" placeholder='YYYY-MM-DD' readOnly/>
                                </div>
                                <div className="m-l-12">
                                  <p className="fs-14 m-b-3 font-weight-700 color-dark-blue">Select Weekdays</p>
                                  <div className="d-flex">
                                    <div onClick={selectWeekDay(member,"Mon")} className={`global-round-btn ${isWekDaySelected(member,"Mon")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Mon")&&`text-white`} flex-item p-l-8 p-r-8`}>Mon</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Tue")} className={`global-round-btn ${isWekDaySelected(member,"Tue")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Tue")&&`text-white`} flex-item p-l-8 p-r-8`}>Tue</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Wed")} className={`global-round-btn ${isWekDaySelected(member,"Wed")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Wed")&&`text-white`} flex-item p-l-8 p-r-8`}>Wed</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Thu")} className={`global-round-btn ${isWekDaySelected(member,"Thu")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Thu")&&`text-white`} flex-item p-l-8 p-r-8`}>Thu</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Fri")} className={`global-round-btn ${isWekDaySelected(member,"Fri")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Fri")&&`text-white`} flex-item p-l-8 p-r-8`}>Fri</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Sat")} className={`global-round-btn ${isWekDaySelected(member,"Sat")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Sat")&&`text-white`} flex-item p-l-8 p-r-8`}>Sat</p>
                                    </div>
                                    <div onClick={selectWeekDay(member,"Sun")} className={`global-round-btn ${isWekDaySelected(member,"Sun")&&`global-round-btn-active`} d-flex m-r-6`}>
                                      <p className={`text ${isWekDaySelected(member,"Sun")&&`text-white`} flex-item p-l-8 p-r-8`}>Sun</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        </div>
                      )
                    })
                  }
                  {isMemberSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                </div>
              </div>
              <div className="d-flex w-full m-t-12 p-l-12 p-r-12">
                <div onClick={(!isButtonLock) ?()=>bookAppointment(null):null} className={`global-button-container ${(!isButtonLock)?'global-button-container-active':'global-button-container-inactive'} d-flex flex-item w-full`} style={{height:"40px", borderRadius:"20px",pointerEvents:(!isButtonLock)?'auto':'none'}}>
                  <p className="flex-item fs-14 color-white" style={{fontWeight:"700"}}>Book Appointment</p>
                </div>
              </div>
              <div className="d-flex w-full m-t-12 p-l-12 p-r-12">
                <div onClick={!blockSlotButtonLock?()=>bookAppointment("blocked"):null} className={`global-button-container ${blockSlotButtonLock && `global-button-container-inactive`} d-flex flex-item w-full`} style={{height:"40px", borderRadius:"20px", backgroundColor:"#9F201C",pointerEvents:(blockSlotButtonLock?'none':'auto')}}>
                  <p className="flex-item fs-14 color-white font-weight-400" style={{color:"#ffffff"}}>Block Appointment Slot</p>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default BookAppointment;